import React, { useEffect, useState } from "react";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import {
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  CardTitle,
  Input,
} from "reactstrap";
import WizardError from "../../auth/register/WizardError";
import { normalizeProfilePhone } from "../../../helpers/phone";
import InternationalPhoneInput from "../../common/InternationalPhoneInput";

const ProfileContact = ({
  phone,
  email,
  edit,
  wasBeEdited,
  errors,
  register,
  setValue,
}) => {
  const [phoneValue, setPhoneValue] = useState(() => normalizeProfilePhone(phone));

  useEffect(() => {
    register("phone", {
      validate: (value) =>
        !value ||
        isPossiblePhoneNumber(value) ||
        "Introduce un teléfono válido para el país seleccionado.",
    });
  }, [register]);

  useEffect(() => {
    const normalized = normalizeProfilePhone(phone);
    setPhoneValue(normalized);
    setValue("phone", normalized);
  }, [phone, setValue]);

  // El input de email queda registrado como "uncontrolled" por react-hook-form
  // y usa defaultValue solo al montar. Cuando el form se remonta (p.ej. tras
  // guardar), RHF puede reusar un valor vacío que quedó cacheado de un render
  // previo, así que forzamos el valor actual cada vez que cambia el prop.
  useEffect(() => {
    setValue("email", email);
  }, [email, setValue]);

  return (
    <>
      <CardBody className="pb-0">
        <CardTitle tag="h5">Información de contacto</CardTitle>

        <Row form>
          <Col sm>
            <FormGroup>
              <Label for="email">Correo electrónico</Label>
              <Input
               onChange={wasBeEdited}
                id="email"
                name="email"
                type="email"
                disabled={!edit}
                autoComplete="off"
                placeholder="Correo electrónico"
                innerRef={register({
                  pattern: {
                    value:
                      /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
                    message: "Correo electrónico debe ser válido.",
                  },
                })}
                defaultValue={email}
              />
            </FormGroup>
            <WizardError error={errors.email?.message} className="mt-1" />
          </Col>
        </Row>
        <Row form>
          <Col tag={FormGroup}>
            <Label for="phone">Teléfono</Label>
            <InternationalPhoneInput
              id="phone"
              name="phone"
              disabled={!edit}
              autoComplete="tel"
              placeholder="Número de teléfono"
              aria-describedby={`phone-help${errors.phone ? " phone-error" : ""}`}
              invalid={Boolean(errors.phone)}
              value={phoneValue || undefined}
              onChange={(value) => {
                setPhoneValue(value || "");
                setValue("phone", value || "", {
                  shouldDirty: true,
                  shouldValidate: true,
                });
                wasBeEdited();
              }}
            />
            <small id="phone-help" className="form-text text-muted">
              Selecciona el país e introduce el número.
            </small>
            <WizardError
              id="phone-error"
              role="alert"
              error={errors.phone?.message}
              className="mt-1"
            />
          </Col>
        </Row>
      </CardBody>
    </>
  );
};

export default ProfileContact;
